import { Lang } from 'cat-shared/utils'
import { APP_NAME, APP_NAME_SHORT } from 'client/utils'

export default {
  [Lang.EN]: {
    topBar: {
      appName: APP_NAME,
      appNameShort: APP_NAME_SHORT,
      browse: {
        label: 'Places',
        items: {
          home: 'Home',
          all: 'Question browser',
          random: 'Randomizer',
        },
      },
      creator: 'Creator',
      bestOfTheBest: 'Best of the best',
      dataManager: 'Data manager',
      ui: 'UI',
      menu: {
        label: 'Account',
        items: {
          profile: 'Profile',
          settings: 'Settings',
          logout: 'Log out',
          login: 'Log in',
          register: 'Register',
        },
      },
      loggedInAs: 'Logged in as',
      loggedOut: 'Logged out',
      dontHaveAnAccount: "Don't have an account yet ? Click to register",
    },
    footer: {
      section1: {
        header: 'About',
        content:
          '"Can Answer That ?" is a Quiz Web application consisting of tons of questions divided into different categories.',
      },
      section2: {
        header: 'Contact',
        content:
          'Do not hesitate to get in touch in case you have some questions, comments or suggestions.',
      },
      section3: {
        header: 'Support',
        content:
          'The project is completely free but if you will, you can support us by donating some small amount of money using STRIPE PAYMENTS.',
        fbBtn: 'FB fan page',
      },
    },
    activationBox: {
      header: 'Email verification',
      description:
        'The last step is to confirm your email address in order to finish registering and fully activate your account. Please click the button below to receive verification link and check your mail inbox for further instructions. Thank you !',
      buttons: {
        send: 'Send me verification link',
        sent: 'Verification link sent',
      },
    },
  },
}
